<template>
  <div :class='{ fixedNavbar: isfixTab }' id="testNavBar">
    <div class="page-header">
      <div class="nav-block">
        <a href="/home" class="left-logo"></a>
        <!-- <div class="nav-list" id="navList"> -->
        <!-- <div class="nav-list-left"> -->
        <ul class="nav-list-left navUl">
          <li v-for="(item, index) in navList" :key="index" @mouseenter="changeTitle(index)" class="nav-list--active">
            <div class="li-link"><a :href="item.href" class="link">{{item.title}}</a></div>
            <!-- 菜单1 -->
            <div class="" v-if="index==0">
              <div class="subMenu">
                <div class="subContent">
                  <a href="/product-solution" class="subList nav-list--active">
                    全屋活水解决方案
                  </a>
                  <a href="https://www.cbpipe.com/" class="subList" target="_blank">
                    建筑管路系统综合解决方案
                  </a>
                  <a href="http://www.ibpchina.com/" class="subList" target="_blank">
                    流体控制解决方案
                  </a>
                </div>
              </div>
              <div class="subMenu sub-2">
                <div class="subContent secondary">
                  <a href="/product-six-dimensional" class="subList">
                    六维全面水管理体系
                  </a>
                  <a href="/product-supply-system" class="subList nav-list--active">
                    给水系统
                  </a>
                  <a href="/product-drainage-system" class="subList">
                    排水系统
                  </a>
                </div>
              </div>
              <div class="subMenu sub-3">
                <div class="subContent third">
                  <a href="/product-supply-system#p1" class="subList">
                    贝瑞斯系列
                  </a>
                  <a href="/product-supply-system#p2" class="subList">
                    普乐仕系列
                  </a>
                  <a href="/product-supply-system#p3" class="subList">
                    梵尔西/伊耐斯系列
                  </a>
                  <a href="/product-supply-system#p4" class="subList">
                    法斯特系列
                  </a>
                  <a href="/product-supply-system#p5" class="subList">
                    住宅给水阀门系列
                  </a>
                  <a href="/product-supply-system#p6" class="subList">
                    工程不锈钢系列
                  </a>
                </div>
              </div>
            </div>

            <!-- 菜单2 -->
            <div class="subMenu" v-if="index==1">
              <div class="subContent">
                <a href="/service" class="subList">
                  班管家365服务
                </a>
                <a href="https://oms.idcgroup.com.cn:8082/BGJGZH/index.html" class="subList">
                  班管家服务平台
                </a>
                <a href="/service2" class="subList">
                  班管家系统配置
                </a>
              </div>
            </div>

            <!-- 菜单3 -->
            <div class="subMenu" v-if="index==2">
              <div class="subContent">
                <a href="/life" class="subList">
                  知水擅水
                </a>
                <a href="/appointment" class="subList">
                  展厅预约
                </a>
              </div>
            </div>

            <!-- 菜单4 -->
            <div class="" v-if="index==3">
              <div class="subMenu">
                <div class="subContent">
                  <a href="/about" class="subList">
                    关于班尼戈
                  </a>
                  <a href="/explore" class="subList">
                    百年传承
                  </a>
                  <a href="/news" class="subList">
                    新闻动态
                  </a>
                  <a href="javascript:;" class="subList nav-list--active">
                    优秀案例
                  </a>
                  <a href="/contact" class="subList">
                    联系我们
                  </a>
                </div>
              </div>
              <div class="subMenu sub-2">
                <div class="subContent secondary">
                  <a href="/global-case" class="subList">
                    全球案例
                  </a>
                  <a href="/china-case" class="subList">
                    中国案例
                  </a>
                </div>
              </div>
            </div>

          </li>
        </ul>
        <!-- </div> -->
        <div class="nav-icons">
          <a href="http://www.conexbanninger.com/" target="_blank" class="icon-link"></a>
          <div class="icon"></div>
        </div>
      </div>
      <!-- <div class="Sub">
      <div class="menu"></div>
    </div> -->
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  props: {
    activeId: {
      type:  [Number],
      default: 0
    }
  },
  data() {
    return {
        show: false,
        navList: [
            {'href':'javascript:;','title':'产品与技术'},
            {'href':'javascript:;','title':'班管家服务'},
            {'href':'javascript:;','title':'舒享水生活'},
            {'href':'javascript:;','title':'探索班尼戈'}
        ],
        active: 0,
        translateX: 0,

        isnavshow: false,
        cateList:[],
        cateInfo:[],
        config_list:{},
        isfixTab:false
    }
  },
  mounted() {
    this.active = this.activeId
    // this.setUnderLine();
    // $('.nav-btm-line').css({
    //   left: 0 + 'px'
    // });
    $(".navUl li").hover(function () {
        $(this).addClass("hover");
        $(this).find(".subMenu").stop(false, true).fadeIn(300)
    }, function () {
        $(this).removeClass("hover");
        $(this).find(".subMenu").stop(false, true).fadeOut(300)
    });

    window.addEventListener('scroll', this.handleTabFix, true)

    // this.$nextTick((res) => {
    //   console.log(res)
    //   let img = this.$refs.img;
    //   this.timer= setTimeout(() => {
    //       img.style.objectFit = 'scale-down';
    //       //当图片的objectFit 发生变化时，图片的显示会出现闪现的抖动
    //       img.style.visibility = 'visible';
    //     }, 100);
    // });
  },
  // beforeDestroy() {
  //   //  页面关闭时清除定时器
  //   clearInterval(this.timer);
  // },
  // 离开当前组件前一定要清除滚动监听，否则进入其他路由会报错
  beforeRouteLeave (to, from, next) {
    window.removeEventListener('scroll', this.handleTabFix, true)
    next()
  },
  methods: {
    handleTabFix(){
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      var offsetTop = document.querySelector('#testNavBar').offsetTop
      scrollTop > offsetTop ? this.isfixTab = true : this.isfixTab = false
    },
    changeTitle(index) {
        console.log(index)
        this.active = index;
        // this.setUnderLine();
    },
    setUnderLine() {
      // 屏幕宽
      //   let width = document.documentElement.clientWidth;
      let width = document.getElementById('navList').clientWidth;
      // console.log(width)
      // 每个菜单所占宽度 = 屏宽 / 菜单个数
      let slidingWidth = (width / this.navList.length).toFixed(2);
      // 半个菜单宽度 （为了将下划线与菜单对齐）
      let halfSlidingWidth = (slidingWidth / 2).toFixed(2);
      // 水平位移目的坐标 = 半个菜单宽度 + (菜单宽 x 当前所在的index)
      this.translateX = Number(halfSlidingWidth) + Number(slidingWidth * this.active);
    }
  } 
};
</script>

<style scoped lang="less">

</style>